import React, { Fragment, useEffect, useState } from "react";
import InformationComponent from "./InformationComponent";
import CwdComponent from "./CwdComponent";
import CslfComponent from "./CslfComponent";

const ShowInfo = (props) => {
  const { csInformation, csLogCustomers, csLogData } = props;
  const [customerWiseData, setCustomerWiseData] = useState([]);
  const [searchValues, setSearchValues] = useState({});
  const [cwdSearchValue, setCwdSearchValue] = useState("");
  const [cslfSearchValue, setCslfSearchValue] = useState("");
  const customerIds = csLogCustomers?.length > 0 ? Array.from(new Set(csLogCustomers?.filter((item) => item.customer_id !== "").map((item) => item.customer_id))) : [];
  const rfIds = csLogCustomers?.length > 0 ? Array.from(new Set(csLogCustomers?.filter((item) => item.rfid !== "").map((item) => item.rfid))) : [];

  useEffect(() => {
    setCustomerWiseData(csLogCustomers);
    setCwdSearchValue("");
    setCslfSearchValue("");
  }, [csLogCustomers])

  const onCustomerIDClick = (id) => {
    setCustomerWiseData(csLogCustomers?.filter((item) => item.customer_id === id));
  }

  const onRfidIDClick = (id) => {
    setCustomerWiseData(csLogCustomers?.filter((item) => item.rfid === id));
  }

  const handleSearchChange = (e, key) => {
    setSearchValues({
      ...searchValues,
      [key]: e.target.value.toLowerCase(),
    });
  };

  const clearIdFilters = () => {
    setCustomerWiseData(csLogCustomers);
  }

  return <Fragment>
    <div className="row">
      <div className="col-md-8 g-3">
        <InformationComponent csInformation={csInformation} />
      </div>
      <div className="col-md-4 g-3">
        <div className="border border-success border-1 rounded-2 border-opacity-25 p-2" style={{ height: '190px', overflow: 'hidden', backgroundColor: '#ecf2ea' }}>
          <div className="row">
            <div className="col">
              <div className="d-flex">
                <div>
                  <h6 className="text-success text-center">CUSTOMER IDs</h6>
                </div>
              </div>
              <div className="custom-scrollbar border bg-white" style={{ height: '140px', overflowY: 'auto' }}>
                {customerIds.length > 0 ?
                  customerIds.map(id =>
                    <div key={id} className="border p-2">
                      <button
                        type="button"
                        key={id}
                        onClick={(e) => {
                          e.preventDefault();
                          onCustomerIDClick(id);
                          const allIdButtons = document.querySelectorAll('.btn.active.btn-sm');
                          allIdButtons.forEach((button) => button.classList.remove('bg-success-subtle'));
                          e.target.classList.add('bg-success-subtle')
                        }}
                        className="btn active btn-sm"
                        data-bs-toggle="button"
                        aria-pressed="true"
                        style={{ fontSize: '12px', padding: '3px 5px', margin: '0px', border: '1px solid grey' }}
                        onMouseOver={(e) => e.target.classList.add('bg-secondary-subtle')}
                        onMouseOut={(e) => e.target.classList.remove('bg-secondary-subtle')}
                      >
                        {id}
                      </button>
                    </div>
                  ) :
                  (
                    <div className="text-center">No matching records found</div>
                  )
                }
              </div>
            </div>
            <div className="col">
              <div className="d-flex">
                <div>
                  <h6 className="text-success text-center">RFIDs</h6>
                </div>
                <div className="ms-auto">
                  <button
                    type="button"
                    style={{ border: '1px solid lightgreen', borderRadius: '10px', padding: '1px 12px' }}
                    onClick={(e) => {
                      const allIdButtons = document.querySelectorAll('.btn.active.btn-sm');
                      allIdButtons.forEach((button) => button.classList.remove('bg-success-subtle'));
                      clearIdFilters();
                    }}
                    onMouseOver={(e) => e.target.classList.add('bg-success-subtle')}
                    onMouseOut={(e) => e.target.classList.remove('bg-success-subtle')}
                  >
                    Clear Filter
                  </button>
                </div>
              </div>
              <div className="custom-scrollbar border bg-white" style={{ height: '140px', overflowY: 'auto' }}>
                {rfIds.length > 0 ?
                  rfIds.map(id =>
                    <div key={id} className="border p-2">
                      <button
                        type="button"
                        key={id}
                        onClick={(e) => {
                          e.preventDefault();
                          onRfidIDClick(id);
                          const allIdButtons = document.querySelectorAll('.btn.active.btn-sm');
                          allIdButtons.forEach((button) => button.classList.remove('bg-success-subtle'));
                          e.target.classList.add('bg-success-subtle')
                        }}
                        className="btn active btn-sm"
                        data-bs-toggle="button"
                        aria-pressed="true"
                        style={{ fontSize: '12px', padding: '3px 5px', margin: '0px', border: '1px solid grey' }}
                        onMouseOver={(e) => e.target.classList.add('bg-secondary-subtle')}
                        onMouseOut={(e) => e.target.classList.remove('bg-secondary-subtle')}
                      >
                        {id}
                      </button>
                    </div>
                  ) :
                  (
                    <div className="text-center">No matching records found</div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="row mb-3 pb-3">
      <div className="col-md-6 g-3">
        <CwdComponent
          customerWiseData={customerWiseData}
          cwdSearchValue={cwdSearchValue}
          setCwdSearchValue={setCwdSearchValue}
          searchValues={searchValues}
          handleSearchChange={handleSearchChange}
        />
      </div>
      <div className="col-md-6 g-3">
        <CslfComponent
          csLogData={csLogData}
          cslfSearchValue={cslfSearchValue}
          setCslfSearchValue={setCslfSearchValue}
          searchValues={searchValues}
          handleSearchChange={handleSearchChange}
        />
      </div>
    </div>
  </Fragment>
}

export default ShowInfo;
